import { registerPlugin } from './registerPlugin'
import type {
  NotificationBridge,
  NotificationBridgeEvents,
  GestureBridge,
  GestureBridgeEvents
} from './Bridges'

export class NativePlugins {
  static readonly GesturePlugin = registerPlugin<
    GestureBridge,
    GestureBridgeEvents
  >('GesturePlugin')

  static readonly NotificationPlugin = registerPlugin<
    NotificationBridge,
    NotificationBridgeEvents
  >('NotificationPlugin')
}
